import React from "react";
import RecentWorkGallery from "@/components/RecentWorkGallery";

export default function RecentWorkPage() {
    return (
        <div data-testid="recent-work-page" className="max-w-7xl mx-auto px-6 sm:px-10 py-12">
            <div className="text-center mb-12">
                <div className="label-eyebrow text-gold mb-3">/ Portfolio</div>
                <h1 className="font-serif text-4xl sm:text-6xl">
                    Recent <span className="italic gold-text">work</span>.
                </h1>
                <p className="text-slate-400 text-sm mt-5 max-w-2xl mx-auto leading-relaxed">
                    A glimpse at the Central Florida homes The Butler Room has cared for this season.
                    Every photo is from a real client who rated us 5 stars after the job. Identifying
                    details have been removed for privacy.
                </p>
            </div>
            <RecentWorkGallery limit={48} title="Recent work" />
        </div>
    );
}
